"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceFeeTermsSchema = void 0;
const zod_1 = require("zod");
exports.ServiceFeeTermsSchema = zod_1.z.object({
    percentage: zod_1.z.string().regex(/^\d{1,2}(\.\d{1,3})?$/),
    fixedUsd: zod_1.z.string().regex(/^\d{1,9}(\.\d{1,2}0?)?$/),
}).strict();
//# sourceMappingURL=service-fee-terms.js.map